import EntryCard from "./EntryCard";

// Timeline view (product rule 1): the SAME entries as the board, ordered
// newest-first and grouped by month. Status is still changeable here via
// the card's quick-select pill, so the two views are one truth.
function entryTime(e) {
  const t = new Date(e.updated_at || e.created_at || e.date || 0).getTime();
  return Number.isNaN(t) ? 0 : t;
}

function monthKey(ms) {
  const d = new Date(ms);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

function monthLabel(ms) {
  // English month labels regardless of host locale.
  return new Date(ms).toLocaleDateString("en-US", { month: "long", year: "numeric" });
}

const TimelineView = ({ entries, onStatusChange, onEdit, onDelete, onOpenThread, canModify }) => {
  const sorted = [...entries].sort((a, b) => entryTime(b) - entryTime(a));
  const groups = [];
  let current = null;
  for (const e of sorted) {
    const key = monthKey(entryTime(e));
    if (!current || current.key !== key) {
      current = { key, label: monthLabel(entryTime(e)), items: [] };
      groups.push(current);
    }
    current.items.push(e);
  }

  if (sorted.length === 0) {
    return (
      <p className="text-[13.5px] text-[#667085] text-center py-10">
        No entries yet. Log your first call, meeting or offer.
      </p>
    );
  }

  return (
    <div className="flex flex-col gap-6 max-w-2xl">
      {groups.map((g) => (
        <div key={g.key}>
          <div className="flex items-center gap-3 mb-3">
            <span className="text-[12px] font-semibold uppercase tracking-wider text-[#98A2B3]">
              {g.label}
            </span>
            <span className="h-px flex-1 bg-[#EAECF0]" />
          </div>
          <div className="flex flex-col gap-2.5">
            {g.items.map((entry) => (
              <EntryCard
                key={entry.id}
                entry={entry}
                canModify={canModify ? canModify(entry) : false}
                onStatusChange={onStatusChange}
                onEdit={onEdit}
                onDelete={onDelete}
                onOpenThread={onOpenThread}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default TimelineView;
